import {
  getVideoPPIDs,
  setXandrPPIDs,
} from '@sch-inventory/advertory/features/tracker';
import type { Country } from '@sch-inventory/advertory/types/core/interface/countries';
import type { Tracker } from '@schibsted/pulse-sdk';
import type { Player } from '@schibsted-svp/web-player';
import type { Provider } from '@vgtv/api-client';

import { resolveWithTimeout } from '../../../utils/async';
import { getConfigProvider } from '../../../utils/player/player';

import { getPulseTracker } from './getPulseTracker';
import { countryMap } from '../../countryMap';

const DEFAULT_TIMEOUT_IN_MILLISECONDS = 2500;

export class PpidWrapper {
  private provider: Provider;

  private country: 'no' | 'se';

  ready: Promise<void>;

  tracker: Tracker | null = null;

  constructor(player: Player) {
    this.provider = getConfigProvider(player);
    this.country = (Object.keys(countryMap).find((k) =>
      countryMap[k].includes(this.provider)
    ) ?? 'no') as Country;

    this.ready = resolveWithTimeout({
      promise: getPulseTracker(player).then(async (tracker) => {
        if (!tracker) {
          return;
        }

        this.tracker = tracker;

        await setXandrPPIDs({
          country: this.country,
          tracker: {
            clientId: this.provider,
            instance: this.tracker,
          },
          timeout: DEFAULT_TIMEOUT_IN_MILLISECONDS,
        });
      }),
      fallback: undefined,
      timeout: DEFAULT_TIMEOUT_IN_MILLISECONDS,
    });
  }

  async getEids(): Promise<string> {
    await this.ready;

    try {
      return await getVideoPPIDs(this.country);
    } catch (error) {
      console.error('Error fetching video PPIDs:', error);
      return '';
    }
  }
}
